<template>
  <b-container fluid>
    <h1>Preview Schedule</h1>
    <div class="form-group row">
      <label for="startTime" class="col-sm-2 col-form-label">Start time</label>
      <div class="col-sm-10">
        <input type="time" class="form-control" id="startTime" v-model="startTime">
      </div>
    </div>
    <b-tabs>
      <b-tab
        v-for="t in tabs"
        :key="t.id"
        :title="t.title"
        @click="setTab(t.id)"
      >
        <div v-if="currentTab === -1">
          <b-row class="bg-dark text-light py-2">
            <b-col>Weight class</b-col>
            <b-col>Rules/Bracket</b-col>
            <b-col>Red Corner</b-col>
            <b-col>Blue Corner</b-col>
            <b-col>Duration</b-col>
          </b-row>
          <vuedraggable v-model="schedule">
          <div v-for="f in schedule" :key="f.kind + f.id" class="border-top">
            <b-row v-if="f.kind === 'tournamentFight'" :class="{ 'table-danger': isFemale(f) }">
              <b-col>{{ getWeightClassDetail(weightClass(f).weight).stringDe }}</b-col>
              <b-col class="border-left">
                <span v-if="f.nr === 1">Finals</span>
                <span v-if="f.nr === 2">Semi Finals 1</span>
                <span v-if="f.nr === 3">Semi Finals 2</span>
                <span v-if="f.nr === 4">Quarter Finals 1</span>
                <span v-if="f.nr === 5">Quarter Finals 2</span>
                <span v-if="f.nr === 6">Quarter Finals 3</span>
                <span v-if="f.nr === 7">Quarter Finals 4</span>
                <br>
                <span class="text-muted small">Tournament</span>
              </b-col>
              <b-col class="border-left">
                <span v-if="!f.athleteRed">
                  <span v-if="f.classId === 1">Winner of Semi-Finals 1</span>
                  <span v-if="f.classId === 2">Winner of Quarter-Finals 1</span>
                  <span v-if="f.classId === 3">Winner of Quarter-Finals 3</span>
                </span>
                <span v-else>
                  {{ athleteName(f.athleteRed) }}<br>
                  <span class="text-muted small">{{ athleteTeam(f.athleteRed) }}</span>
                </span>
              </b-col>
              <b-col class="border-left">
                <span v-if="!f.athleteBlue">
                  <span v-if="f.classId === 1">Winner of Semi-Finals 2</span>
                  <span v-if="f.classId === 2">Winner of Quarter-Finals 2</span>
                  <span v-if="f.classId === 3">Winner of Quarter-Finals 4</span>
                </span>
                <span v-else>
                  {{ athleteName(f.athleteBlue) }}<br>
                  <span class="text-muted small">{{ athleteTeam(f.athleteBlue) }}</span>
                </span></b-col>
              <b-col class="border-left">{{ f.rounds }} x {{ $formattedTime(f.duration) }}</b-col>
            </b-row>
            <b-row v-else class="font-weight-bold">
              <b-col>{{ getWeightClassDetail(f.weightClass).stringDe }}</b-col>
              <b-col class="border-left text-capitalize">
                {{ f.type }}<br><span class="text-muted small">Match fight</span>
              </b-col>
              <b-col class="border-left">
                {{ athleteName(f.athleteRed) }}<br>
                <span class="text-muted small">{{ athleteTeam(f.athleteRed) }}</span>
              </b-col>
              <b-col class="border-left">
                {{ athleteName(f.athleteBlue) }}<br>
                <span class="text-muted small">{{ athleteTeam(f.athleteBlue) }}</span>
              </b-col>
              <b-col class="border-left">{{ f.rounds }} x {{ $formattedTime(f.duration) }}</b-col>
            </b-row>
          </div>
        </vuedraggable>
        </div> <!-- Schedule Tab -->
        <div v-if="currentTab === -2">
          <b-table
            :fields="fieldsMatchFights"
            head-variant="dark"
            small
            :items="matchFights"
          >
            <template v-slot:cell(weightClass)="data">
              {{ getWeightClassDetail(data.item.weightClass).stringDe }}
            </template>
            <template v-slot:cell(athleteRed)="data">
              {{ data.item.athleteRed.name }}<br>
              <span class="text-muted small">{{ data.item.athleteRed.team }}</span>
            </template>
            <template v-slot:cell(athleteBlue)="data">
              {{ data.item.athleteBlue.name }}<br>
              <span class="text-muted small">{{ data.item.athleteBlue.team }}</span>
            </template>
            <template v-slot:cell(duration)="data">
              {{ data.item.rounds }} x {{ $formattedTime(data.item.duration) }}
            </template>
          </b-table>
        </div> <!-- Match Fights Tab -->
        <div v-if="currentTab >= 0">
          <b-table
            :fields="fieldsTournament"
            head-variant="dark"
            small
            :items="fightsOfTab"
          >
            <template v-slot:cell(bracket)="data">
              <span v-if="data.item.nr === 1">Finals</span>
              <span v-if="data.item.nr === 2">Semi Finals 1</span>
              <span v-if="data.item.nr === 3">Semi Finals 2</span>
              <span v-if="data.item.nr === 4">Quarter Finals 1</span>
              <span v-if="data.item.nr === 5">Quarter Finals 2</span>
              <span v-if="data.item.nr === 6">Quarter Finals 3</span>
              <span v-if="data.item.nr === 7">Quarter Finals 4</span>
            </template>
            <template v-slot:cell(athleteRed)="data">
                <span v-if="!data.item.athleteRed">
                  <span v-if="data.item.classId === 1">Winner of Semi-Finals 1</span>
                  <span v-if="data.item.classId === 2">Winner of Quarter-Finals 1</span>
                  <span v-if="data.item.classId === 3">Winner of Quarter-Finals 3</span>
                </span>
              <span v-else>
                {{ athleteName(data.item.athleteRed) }}<br>
                <span class="text-muted small">{{ athleteTeam(data.item.athleteRed) }}</span>
              </span>
            </template>
            <template v-slot:cell(athleteBlue)="data">
                <span v-if="!data.item.athleteBlue">
                  <span v-if="data.item.classId === 1">Winner of Semi-Finals 1</span>
                  <span v-if="data.item.classId === 2">Winner of Quarter-Finals 1</span>
                  <span v-if="data.item.classId === 3">Winner of Quarter-Finals 3</span>
                </span>
              <span v-else>
                {{ athleteName(data.item.athleteBlue) }}<br>
                <span class="text-muted small">{{ athleteTeam(data.item.athleteBlue) }}</span>
              </span>
            </template>
            <template v-slot:cell(duration)="data">
              {{ data.item.rounds }} x {{ $formattedTime(data.item.duration)}}
            </template>
          </b-table>
        </div>
      </b-tab>
    </b-tabs>
    <div class="d-flex justify-content-between">
      <b-button @click="$emit('back')">Back to Matchfights Setup</b-button>
      <b-button variant="success" @click="showModal=true">Finish</b-button>
    </div>
    <b-modal
      centered
      hide-header-close
      header-bg-variant="primary"
      header-text-variant="light"
      title="Create fights"
      v-model="showModal"
    >
      <p>
        Do you really want to create all fights?
      </p>
      <template v-slot:modal-footer>
        <div class="d-flex w-100 justify-content-between">
          <b-button variant="danger" @click="showModal = false">Abort</b-button>
          <b-button variant="success" @click="finish">Confirm</b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import vuedraggable from 'vuedraggable';

export default {
  name: 'SetupSchedule',
  components: { vuedraggable },
  data() {
    return {
      currentTab: -1,
      fields: ['startTime', 'fn', 'weightClass', 'bracket', 'red', 'blue'],
      fieldsMatchFights: ['weightClass', 'type', 'athleteRed', 'athleteBlue', 'duration'],
      fieldsTournament: ['bracket', 'fn', 'athleteRed', 'athleteBlue', 'duration'],
      generalTabs: [
        { id: -1, title: 'Schedule' },
        { id: -2, title: 'Matchfights' },
      ],
      schedule: [],
      showModal: false,
      startTime: null,
    };
  },
  methods: {
    setTab(id) {
      this.currentTab = id;
    },
    athleteName(athlete) {
      if (!athlete) return '';
      return athlete.name;
    },
    athleteTeam(athlete) {
      if (!athlete) return '';
      return athlete.team;
    },
    getWeightClassDetail(weight) {
      return this.$weightClasses().find((wc) => wc.weight === weight);
    },
    isFemale(f) {
      return this.weightClass(f).gender === 'female';
    },
    weightClass(fight) {
      return this.$store.state.setup.classes.find((c) => c.id === fight.classId);
    },
  },
  computed: {
    fights() {
      return this.tournamentFights.concat(this.matchFights);
    },
    fightsOfTab() {
      return this.tournamentFights.filter((f) => f.classId === this.currentTab);
    },
    matchFights() {
      // eslint-disable-next-line
      const fights = this.$store.state.setup.matchFights.fights;
      // eslint-disable-next-line
      fights.forEach((fight) => fight.kind = 'matchFight');
      return fights;
    },
    tournamentClassesStrings() {
      const classes = [];
      // eslint-disable-next-line
      for (const c of this.$store.state.setup.classes) {
        classes.push({
          id: c.id,
          title: `${this.getWeightClassDetail(c.weight).stringDe}`,
        });
      }
      return classes;
    },
    tournamentFights() {
      // eslint-disable-next-line
      const fights = this.$store.state.setup.classes.map((clazz) => clazz.fights)
        .reduce((a, b) => a.concat(b), []);
      // eslint-disable-next-line
      fights.forEach((fight) => fight.kind = 'tournamentFight');
      return fights;
    },
    getFights() {
      if (this.generalTabs.includes(this.currentTab)) return this.fights;
      return this.fights.filter((f) => f.weightClass === this.currentTab);
    },
    tabs() {
      return this.generalTabs.concat(this.tournamentClassesStrings);
    },
  },
  created() {
    this.schedule = this.fights;
  },
};
</script>

<style scoped>

</style>
